import cx from 'classnames'

import { formatJackpotTickerValue, type JackpotTickerFormatMode } from './formatJackpotTickerValue'
import classes from './styles.module.scss'

type Props = {
  amount: number
  currency: 'GC' | 'SC'
  className?: string
  formatMode?: JackpotTickerFormatMode
}

export default function JackpotTicker({ amount, currency, className, formatMode = 'default' }: Props) {
  const formattedAmount = formatJackpotTickerValue(amount, currency, formatMode)

  return (
    <div className={cx(classes.root, currency === 'SC' ? classes.sc : classes.gc, className)}>
      <span className={classes.text}>
        {currency} {formattedAmount}
      </span>
    </div>
  )
}
